































































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { getElementScrollRemaining } from '@/utils/window'
import memberStore from '../../member.store'
import TournamentHistoryItem from '../../components/TournamentHistoryItem'
import ProfileHeader from '@/modules/member/components/ProfileHeader'
import {
  TournamentGameType,
  MemberTournamentHistoryItemEntity
} from '@/api/tournament'
import { getGameTypes } from '@/utils/gameType'

export interface TournamentGameTypeOption {
  text: string
  value: TournamentGameType
}

@Component({
  components: {
    TournamentHistoryItem,
    ProfileHeader
  }
})
export default class TournamentHistory extends Vue {
  @Prop({ default: true }) isDisplayHeader!: boolean

  memberModule = getModule(memberStore, this.$store)
  gameFilter: TournamentGameType = TournamentGameType.All
  isLoading: boolean = false
  isInitializing: boolean = true

  /* Wathcers */
  @Watch('gameFilter')
  async onGameFilterChanged(value: TournamentGameType) {
    this.memberModule.resetMemberTournamentHistory()
    await this.fetchTournamentHistory()
  }

  /* Hooks */
  async created() {
    await this.fetchTournamentHistory()
  }

  /* Vuex Store */
  get tournamentHistoryItems() {
    return this.memberModule.tournamentHistory
  }

  get page() {
    return this.memberModule.tournamentHistoryCurrentPage
  }

  get hasMorePage() {
    return this.memberModule.tournamentHistoryHasMorePage
  }

  get games(): TournamentGameTypeOption[] {
    const gameTypes = getGameTypes()
    var games = [
      {
        text: this.$t('TournamentHistory.AllGames'),
        value: TournamentGameType.All
      }
    ]
    gameTypes.map(gameType => {
      games.push({
        text: gameType.name,
        value: gameType.code as TournamentGameType
      })
    })
    return games
  }

  /* Methods */
  async fetchTournamentHistory() {
    this.isLoading = true
    await this.memberModule.fetchMemberTournamentHistory({
      page: this.page + 1,
      game: this.gameFilter
    })
    this.isLoading = false
    this.isInitializing = false
  }

  async scrollBehavior(event: Event) {
    if (
      getElementScrollRemaining(event.target as HTMLElement) <= 50 &&
      this.hasMorePage &&
      !this.isLoading
    ) {
      await this.fetchTournamentHistory()
    }
  }
}
